export default __webpack_public_path__ + "static/media/Major Rune Stone of the Eternal Blaze.b926d18d.jpg";